

// // import {
// //   Button,
// //   Card,
// //   CardContent,
// //   Grid,
// //   TextField,
// //   Typography,
// //   Divider,
// //   Modal,
// //   Box,
// //   Table,
// //   CircularProgress,
// // } from "@mui/material";
// // import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
// // import React, { useEffect, useState } from "react";
// // import axios from "axios";
// // import { useNavigate } from "react-router-dom";
// // import HOST_URL from "../../../utils/Url";
// // import { useFormik } from "formik";
// // import * as Yup from "yup";
// // import { useTranslation } from "react-i18next";
// // import { toast } from "react-toastify";
// // import ToastApp from "../../../ToastApp";
// // import Autocomplete from "@mui/material/Autocomplete";
// // import { useLocation } from "react-router-dom";
// // import nopdf from "../../../assets/images/nopdf.png";
// // import dayjs from "dayjs";
// // import moment from "moment";
// // import DeleteIcon from "@mui/icons-material/Delete";
// // import AddCircleIcon from "@mui/icons-material/AddCircle";

// // const style = {
// //   position: "absolute" as "absolute",
// //   top: "50%",
// //   left: "50%",
// //   transform: "translate(-50%, -50%)",
// //   width: "180vh",
// //   height: "85vh",
// //   bgcolor: "#f5f5f5",
// //   border: "1px solid #000",
// //   boxShadow: 24,
// //   p: 4,
// //   borderRadius: 10,
// // };

// // type Props = {};

// // const DocumentEntryEdit = (props: Props) => {
// //   var someDate = new Date();
// //   var date = someDate.setDate(someDate.getDate());
// //   var defaultValues = new Date(date).toISOString().split("T")[0];

// //   const today = moment().format("YYYY-MM-DD");

// //   const { i18n, t } = useTranslation();

// //   const [TypeOption, setTypeOption] = useState<any>([
// //     { value: "-1", label: t("text.SelectFile") },
// //   ]);
// //   const [Subject, setSubject] = useState<any>([
// //     { value: "-1", label: t("text.SelectSubject") },
// //   ]);
// //   const [Division, setDivision] = useState<any>([
// //     { value: "-1", label: t("text.SelectDepartment") },
// //   ]);

// //   const [Opens, setOpen] = React.useState(false);
// //   const [Img, setImg] = useState<any>("");
// //   const [loader, setLoader] = useState(false);

// //   const handlePanClose1 = () => {
// //     setOpen(false);
// //   };
// //   const modalOpenHandle1 = (event: any) => {
// //     setOpen(true);
// //     setImg(event);
// //   };

// //   useEffect(() => {
// //     getDocManagerbyID();
// //     getFileType();
// //     getSubject();
// //     getDivision();
// //   }, []);

// //   const getDocManagerbyID = async () => {
// //     const collectData = {
// //       docMid: location.state.docMid,
// //       fileTypId: -1,
// //       divisionid: -1,
// //       subsubjId: -1,
// //       user_Id: -1,
// //       fileNo: "",
// //     };
// //     await axios
// //       .post(HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`, collectData)
// //       .then((res) => {
// //         var member_DocFiles;
// //         for (let index = 0; index < res.data.data?.length; index++) {
// //           member_DocFiles = res.data.data[index]["member_DocFiles"];
// //           const arrtabledata = [];
// //           for (let index = 0; index < member_DocFiles?.length; index++) {
// //             arrtabledata.push({
// //               id: index + 1,
// //               pdFid: member_DocFiles[index]["pdFid"] || "",
// //               pdfName: member_DocFiles[index]["pdfName"] || "",
// //               docMid: member_DocFiles[index]["docMid"] || "",
// //               keywords: member_DocFiles[index]["keywords"] || "",
// //               subFtype: member_DocFiles[index]["subFtype"] || "",
// //               pDate: moment(member_DocFiles[index]["pDate"] || "").format(
// //                 "YYYY-MM-DD"
// //               ),
// //               isMain: member_DocFiles[index]["isMain"] || "",
// //               entryDate: member_DocFiles[index]["entryDate"] || "",
// //               user_id: member_DocFiles[index]["user_id"] || "",
// //               pdfBase64: member_DocFiles[index]["pdfBase64"] || "",
// //               pdfPath: member_DocFiles[index]["pdfPath"] || "", // Include both fields
// //               srn: -1,
// //               isDelete: member_DocFiles[index]["isDelete"] || "",
// //             });
// //           }
// //           setTableData(arrtabledata);
// //           console.log("arrtableData", arrtabledata)
// //         }
// //       });
// //   };

// //   const getFileType = () => {
// //     const collectData = {
// //       docID: -1,
// //       parentDocId: -1,
// //       userId: "",
// //     };
// //     axios
// //       .post(HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`, collectData)
// //       .then((res) => {
// //         const arr = res?.data?.data?.map((item: any) => ({
// //           label: item.doc_Name,
// //           value: item.docID,
// //         }));
// //         setTypeOption(arr);
// //       });
// //   };

// //   const getSubject = () => {
// //     const collectData = {
// //       sID: -1,
// //     };
// //     axios
// //       .post(
// //         HOST_URL.HOST_URL2 + `SubjectMasterForPdf/GetSubjectMasterForPdf`,
// //         collectData
// //       )
// //       .then((res) => {
// //         const arr = res.data.data.map((item: any) => ({
// //           label: item.subject,
// //           value: item.sId,
// //         }));
// //         setSubject(arr);
// //       });
// //   };

// //   const getDivision = () => {
// //     const collectData = {
// //       id: -1,
// //       nodeID: -1,
// //       titleID: -1,
// //     };
// //     axios
// //       .post(HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`, collectData)
// //       .then((res) => {
// //         const arr = res.data.data.map((item: any) => ({
// //           label: item.name,
// //           value: item.id,
// //         }));
// //         setDivision(arr);
// //       });
// //   };

// //   let navigate = useNavigate();

// //   const [toaster, setToaster] = useState(false);
// //   const location = useLocation();
// //   console.log("location", location.state);

// //   const validationSchema = Yup.object({
// //     fileNo: Yup.string().test(
// //       "required",
// //       t("text.reqFileNo"),
// //       function (value: any) {
// //         return value && value.trim() !== "";
// //       }
// //     ),
// //   });

// //   const formik = useFormik({
// //     initialValues: {
// //       docMid: location.state.docMid,
// //       fileDef: location.state.fileDef,
// //       fileNo: location.state.fileNo,
// //       synopsis: location.state.synopsis,
// //       status: location.state.status,
// //       fileType: location.state.fileType,
// //       subj: location.state.subj,
// //       complt: location.state.complt,
// //       fDate: dayjs(location.state.fDate).format("YYYY-MM-DD"),
// //       partNo: location.state.partNo,
// //       pFileNo: dayjs(location.state.pFileNo).format("YYYY-MM-DD"),
// //       perFr: dayjs(location.state.perFr).format("YYYY-MM-DD"),
// //       perUt: dayjs(location.state.perUt).format("YYYY-MM-DD"),
// //       authPersn: location.state.authPersn,
// //       fileTypId: location.state.fileTypId,
// //       subsubjId: location.state.subsubjId,
// //       sub_Subject_Name: location.state.sub_Subject_Name,
// //       divisionid: location.state.divisionid,
// //       createdate: location.state.createdate,
// //       user_Id: location.state.user_Id,
// //       userId: location.state.userId,
// //       member_DocFiles: [],
// //     },

// //     validationSchema: validationSchema,
// //     onSubmit: async (values) => {
// //       setLoader(true);
// //       values.member_DocFiles = tableData;
// //       console.log("Before submission formik values", values);

// //       const response = await axios.post(
// //         HOST_URL.HOST_URL2 + `DocMangr/AddUpdateDocMangr`,
// //         values
// //       );
// //       if (response.data.isSuccess) {
// //         setToaster(false);
// //         toast.success(response.data.mesg);
// //         navigate("/DocManagement/DocumentEntry");
// //         setLoader(false);
// //       } else {
// //         setToaster(true);
// //         toast.error(response.data.mesg);
// //       }
// //     },
// //   });

// //   const requiredFields = ["fileNo"];

// //   const back = useNavigate();

// //   const convertBase64 = (file: Blob) => {
// //     return new Promise((resolve, reject) => {
// //       const fileReader = new FileReader();
// //       fileReader.readAsDataURL(file);
// //       fileReader.onload = () => {
// //         resolve(fileReader.result);
// //       };
// //       fileReader.onerror = (error) => {
// //         reject(error);
// //       };
// //     });
// //   };

// //   const [tableData, setTableData] = useState<any>([]);
// //   const [pDate, setPDate] = useState(today || "");
// //   const [keywords, setKeywords] = useState("");
// //   const [pdfBase64, setPdfBase64] = useState("");
// //   const [fileName, setfileName] = useState("");

// //   const onTransctionChange = async (event: any) => {
// //     event.preventDefault();
// //     if (event.target.files && event.target.files[0]) {
// //       const file = event.target.files[0];
// //       setfileName(file.name);

// //       // Convert to base64 for backend
// //       const base64 = await convertBase64(file);
// //       setPdfBase64(base64 + "");

// //       // Create a preview URL for display
// //       const previewUrl = URL.createObjectURL(file);
// //     }
// //   };

// //   const addMoreRow = () => {
// //     const newRows = {
// //       id: tableData.length + 1,
// //       pdFid: -1,
// //       pdfName: fileName,
// //       docMid: -1,
// //       keywords: keywords,
// //       subFtype: "",
// //       pDate: pDate,
// //       isMain: "",
// //       entryDate: defaultValues,
// //       user_id: -1,
// //       pdfBase64: pdfBase64, // Send base64 to backend
// //       srn: -1,
// //       isDelete: false,
// //     };

// //     setTableData((prevTableData: any) => {
// //       const updatedTableDataed = [...prevTableData, newRows];
// //       return updatedTableDataed;
// //     });
// //     console.log(newRows);

// //     setfileName("");
// //     setPdfBase64("");
// //     setPDate("");
// //     setKeywords("");
// //   };

// //   const removeExtraRow = (id: any) => {
// //     setTableData((prevTableData: any) => {
// //       const updatedTableDataed = prevTableData.filter(
// //         (row: any) => row.id !== id
// //       );
// //       return updatedTableDataed;
// //     });
// //   };

// //   // Function to get the correct PDF source for display
// //   const getPdfSource = (row: any) => {
// //     // First try to use pdfBase64 if available
// //     if (row.pdfBase64 && row.pdfBase64.startsWith('data:')) {
// //       return row.pdfBase64;
// //     }
// //     // Fall back to pdfPath if available
// //     if (row.pdfPath) {
// //       return row.pdfPath;
// //     }
// //     return "";
// //   };

// //   return (
// //     <div>
// //       <div
// //         style={{
// //           padding: "-5px 5px",
// //           backgroundColor: "#ffffff",
// //           borderRadius: "5px",
// //           marginTop: "3vh",
// //         }}
// //       >
// //         <CardContent>
// //           <Typography
// //             variant="h5"
// //             textAlign="center"
// //             style={{ fontSize: "18px", fontWeight: 500 }}
// //           >
// //             {t("text.DocumentEntryEdit")}
// //           </Typography>
// //           <Grid item sm={4} xs={12}>
// //             <Typography style={{ marginTop: "-75px" }}>
// //               <Button
// //                 type="submit"
// //                 onClick={() => back(-1)}
// //                 variant="contained"
// //                 style={{
// //                   marginBottom: 15,
// //                   marginTop: "45px",
// //                   backgroundColor: `var(--header-background)`,
// //                   width: 20,
// //                 }}
// //               >
// //                 <ArrowBackSharpIcon />
// //               </Button>
// //             </Typography>
// //           </Grid>
// //           <Divider />
// //           <br />
// //           <form onSubmit={formik.handleSubmit}>
// //             {toaster === false ? "" : <ToastApp />}
// //             <Grid item xs={12} container spacing={2}>

// //               <Grid item lg={4} sm={3} xs={12}>
// //                 <TextField
// //                   id="fileNo"
// //                   name="fileNo"
// //                   label={
// //                     <span>
// //                       {t("text.EnterFileNo")}{" "}
// //                       {requiredFields.includes("fileNo") && (
// //                         <span
// //                           style={{
// //                             color: formik.values.fileNo ? "green" : "red",
// //                           }}
// //                         >
// //                           *
// //                         </span>
// //                       )}
// //                     </span>
// //                   }
// //                   value={formik.values.fileNo}
// //                   placeholder={t("text.EnterFileNo")}
// //                   size="small"
// //                   fullWidth
// //                   style={{
// //                     backgroundColor: "white",
// //                     borderColor:
// //                       formik.touched.fileNo && formik.errors.fileNo
// //                         ? "red"
// //                         : "initial",
// //                   }}
// //                   onChange={formik.handleChange}
// //                   onBlur={formik.handleBlur}
// //                 />
// //                 {formik.touched.fileNo && formik.errors.fileNo ? (
// //                   <div style={{ color: "red", margin: "5px" }}>
// //                     {String(formik.errors.fileNo)}
// //                   </div>
// //                 ) : null}
// //               </Grid>

// //               <Grid item lg={4} sm={3} xs={12}>
// //                 <TextField
// //                   id="synopsis"
// //                   name="synopsis"
// //                   label={t("text.FileName")}
// //                   value={formik.values.synopsis}
// //                   placeholder={t("text.FileName")}
// //                   size="small"
// //                   fullWidth
// //                   style={{ backgroundColor: "white" }}
// //                   onChange={formik.handleChange}
// //                   onBlur={formik.handleBlur}
// //                 />
// //               </Grid>

// //               <Grid item lg={4} sm={3} xs={12}>
// //                 <TextField
// //                   id="fileDef"
// //                   name="fileDef"
// //                   label={t("text.EnterFileDef")}
// //                   value={formik.values.fileDef}
// //                   placeholder={t("text.EnterFileDef")}
// //                   inputProps={{}}
// //                   size="small"
// //                   type="text"
// //                   fullWidth
// //                   style={{ backgroundColor: "white" }}
// //                   onChange={formik.handleChange}
// //                   onBlur={formik.handleBlur}
// //                 />
// //               </Grid>

// //               <Grid item lg={4} sm={3} xs={12}>
// //                 <TextField
// //                   id="perFr"
// //                   name="perFr"
// //                   label={t("text.EnterPeriodFileFrom")}
// //                   value={formik.values.perFr}
// //                   placeholder={t("text.EnterPeriodFileFrom")}
// //                   InputLabelProps={{ shrink: true }}
// //                   size="small"
// //                   type="date"
// //                   fullWidth
// //                   style={{ backgroundColor: "white" }}
// //                   onChange={formik.handleChange}
// //                   onBlur={formik.handleBlur}
// //                 />
// //               </Grid>

// //               <Grid item lg={4} sm={3} xs={12}>
// //                 <TextField
// //                   id="perUt"
// //                   name="perUt"
// //                   label={t("text.EnterPeriodFileUpto")}
// //                   value={formik.values.perUt}
// //                   placeholder={t("text.EnterPeriodFileUpto")}
// //                   InputLabelProps={{ shrink: true }}
// //                   size="small"
// //                   type="date"
// //                   fullWidth
// //                   style={{ backgroundColor: "white" }}
// //                   onChange={formik.handleChange}
// //                   onBlur={formik.handleBlur}
// //                 />
// //               </Grid>

// //               <Grid item lg={4} sm={3} xs={12}>
// //                 <TextField
// //                   id="authPersn"
// //                   name="authPersn"
// //                   label={t("text.EnterAuthenticatePerson")}
// //                   value={formik.values.authPersn}
// //                   placeholder={t("text.EnterAuthenticatePerson")}
// //                   inputProps={{}}
// //                   size="small"
// //                   type="text"
// //                   fullWidth
// //                   style={{ backgroundColor: "white" }}
// //                   onChange={formik.handleChange}
// //                   onBlur={formik.handleBlur}
// //                 />
// //               </Grid>

// //               <Grid item lg={4} sm={3} xs={12}>
// //                 <TextField
// //                   id="fDate"
// //                   name="fDate"
// //                   label={t("text.EnterFileDate")}
// //                   value={formik.values.fDate}
// //                   placeholder={t("text.EnterFileDate")}
// //                   InputLabelProps={{ shrink: true }}
// //                   size="small"
// //                   type="date"
// //                   fullWidth
// //                   style={{ backgroundColor: "white" }}
// //                   onChange={formik.handleChange}
// //                   onBlur={formik.handleBlur}
// //                 />
// //               </Grid>

// //               <Grid item lg={4} sm={3} xs={12}>
// //                 <Autocomplete
// //                   disablePortal
// //                   id="combo-box-demo"
// //                   options={TypeOption}
// //                   fullWidth
// //                   value={
// //                     TypeOption.find(
// //                       (option: any) => option.value === formik.values.fileTypId
// //                     ) || null
// //                   }
// //                   size="small"
// //                   onChange={(event, newValue: any) => {
// //                     console.log(newValue?.value);
// //                     formik.setFieldValue("fileTypId", newValue?.value);
// //                     formik.setFieldTouched("fileTypId", true);
// //                     formik.setFieldTouched("fileTypId", false);
// //                   }}
// //                   renderInput={(params) => (
// //                     <TextField
// //                       {...params}
// //                       label={
// //                         <span>
// //                           {t("text.SelectFile")} {""}
// //                           {requiredFields.includes("fileTypId") && (
// //                             <span
// //                               style={{
// //                                 color: formik.values.fileTypId
// //                                   ? "green"
// //                                   : "red",
// //                               }}
// //                             >
// //                               *
// //                             </span>
// //                           )}
// //                         </span>
// //                       }
// //                     />
// //                   )}
// //                 />

// //                 {formik.touched.fileTypId && formik.errors.fileTypId ? (
// //                   <div style={{ color: "red", margin: "5px" }}>
// //                     {String(formik.errors.fileTypId)}
// //                   </div>
// //                 ) : null}
// //               </Grid>

// //               <Grid item lg={4} sm={3} xs={12}>
// //                 <Autocomplete
// //                   disablePortal
// //                   id="combo-box-demo"
// //                   options={Subject}
// //                   fullWidth
// //                   size="small"
// //                   value={
// //                     Subject.find(
// //                       (option: any) => option.value === formik.values.subsubjId
// //                     ) || null
// //                   }
// //                   onChange={(event, newValue: any) => {
// //                     console.log(newValue?.value);
// //                     formik.setFieldValue("subsubjId", newValue?.value);
// //                     formik.setFieldValue("sub_Subject_Name", newValue?.label);
// //                     formik.setFieldTouched("subsubjId", true);
// //                   }}
// //                   onBlur={formik.handleBlur}
// //                   renderInput={(params) => (
// //                     <TextField
// //                       {...params}
// //                       label={
// //                         <span>
// //                           {t("text.SelectSubject")} {""}
// //                           {requiredFields.includes("subsubjId") && (
// //                             <span
// //                               style={{
// //                                 color: formik.values.subsubjId
// //                                   ? "green"
// //                                   : "red",
// //                               }}
// //                             >
// //                               *
// //                             </span>
// //                           )}
// //                         </span>
// //                       }
// //                     />
// //                   )}
// //                 />
// //                 {formik.touched.subsubjId && formik.errors.subsubjId ? (
// //                   <div style={{ color: "red", margin: "5px" }}>
// //                     {String(formik.errors.subsubjId)}
// //                   </div>
// //                 ) : null}
// //               </Grid>

// //               <Grid item lg={4} sm={3} xs={12}>
// //                 <Autocomplete
// //                   disablePortal
// //                   id="combo-box-demo"
// //                   options={Division}
// //                   value={
// //                     Division.find(
// //                       (option: any) => option.value === formik.values.divisionid
// //                     ) || null
// //                   }
// //                   fullWidth
// //                   size="small"
// //                   onChange={(event, newValue: any) => {
// //                     console.log(newValue?.value);
// //                     formik.setFieldValue("divisionid", newValue?.value);
// //                     formik.setFieldTouched("divisionid", true);
// //                     formik.setFieldTouched("divisionid", false);
// //                   }}
// //                   renderInput={(params) => (
// //                     <TextField
// //                       {...params}
// //                       label={
// //                         <span>
// //                           {t("text.SelectDepartment")} {""}
// //                           {requiredFields.includes("divisionid") && (
// //                             <span
// //                               style={{
// //                                 color: formik.values.divisionid
// //                                   ? "green"
// //                                   : "red",
// //                               }}
// //                             >
// //                               *
// //                             </span>
// //                           )}
// //                         </span>
// //                       }
// //                     />
// //                   )}
// //                 />

// //                 {formik.touched.divisionid && formik.errors.divisionid ? (
// //                   <div style={{ color: "red", margin: "5px" }}>
// //                     {String(formik.errors.divisionid)}
// //                   </div>
// //                 ) : null}
// //               </Grid>

// //               <Divider />
// //               <br />


// //               <Grid item xs={12} container spacing={2}>
// //                 <Grid xs={12} lg={2.5} item>
// //                   <TextField
// //                     id="pDate"
// //                     name="pDate"
// //                     label={t("text.EnterPeriodDate")}
// //                     value={pDate}
// //                     placeholder={t("text.EnterPeriodDate")}
// //                     InputLabelProps={{ shrink: true }}
// //                     size="small"
// //                     type="date"
// //                     fullWidth
// //                     style={{ backgroundColor: "white" }}
// //                     onChange={(e: any) => setPDate(e.target.value)}
// //                   />
// //                 </Grid>

// //                 <Grid xs={12} lg={2.5} item>
// //                   <TextField
// //                     id="keywords"
// //                     name="keywords"
// //                     label={t("text.EnterKeywords")}
// //                     value={keywords}
// //                     placeholder={t("text.EnterKeywords")}
// //                     size="small"
// //                     type="text"
// //                     fullWidth
// //                     style={{ backgroundColor: "white" }}
// //                     onChange={(e: any) => setKeywords(e.target.value)}
// //                   />
// //                 </Grid>

// //                 <Grid xs={12} lg={2.5} item>
// //                   <TextField
// //                     id="pdf"
// //                     name="pdf"
// //                     label={t("text.AttachedFile")}
// //                     placeholder={t("text.AttachedFile")}
// //                     size="small"
// //                     type="file"
// //                     fullWidth
// //                     style={{ backgroundColor: "white" }}
// //                     InputLabelProps={{ shrink: true }}
// //                     onChange={onTransctionChange}
// //                   />
// //                 </Grid>

// //                 <Grid xs={12} lg={2.5} item>
// //                   <TextField
// //                     id="fileName"
// //                     name="fileName"
// //                     label={t("text.EnterFileName")}
// //                     value={fileName}
// //                     placeholder={t("text.EnterFileName")}
// //                     size="small"
// //                     type="text"
// //                     fullWidth
// //                     style={{ backgroundColor: "white" }}
// //                     inputProps={{ readOnly: true }}
// //                   />
// //                 </Grid>

// //                 <Grid xs={12} lg={2} item>
// //                   <Button
// //                     startIcon={<AddCircleIcon />}
// //                     variant="contained"
// //                     fullWidth
// //                     style={{
// //                       marginBottom: 15,
// //                       backgroundColor: "info",
// //                     }}
// //                     onClick={addMoreRow}
// //                   >
// //                     {t("text.add")}
// //                   </Button>
// //                 </Grid>
// //               </Grid>

// //               <Grid xs={12} sm={12} item sx={{ marginTop: "3px" }}>
// //                 <Table
// //                   style={{
// //                     borderCollapse: "collapse",
// //                     width: "100%",
// //                     border: "1px solid black",
// //                   }}
// //                 >
// //                   <thead
// //                     style={{ backgroundColor: "#2196f3", color: "#f5f5f5" }}
// //                   >
// //                     <tr>
// //                       <th
// //                         style={{
// //                           borderLeft: "1px solid black",
// //                           paddingBlock: "10",
// //                           paddingTop: "5px",
// //                           paddingBottom: "5px",
// //                         }}
// //                       >
// //                         {t("text.Action")}
// //                       </th>
// //                       <th
// //                         style={{
// //                           borderLeft: "1px solid black",
// //                           paddingTop: "5px",
// //                           paddingBottom: "5px",
// //                         }}
// //                       >
// //                         {t("text.PeriodDate")}
// //                       </th>
// //                       <th
// //                         style={{
// //                           borderLeft: "1px solid black",
// //                           paddingTop: "5px",
// //                           paddingBottom: "5px",
// //                         }}
// //                       >
// //                         {t("text.Keywords")}
// //                       </th>
// //                       <th
// //                         style={{
// //                           borderLeft: "1px solid black",
// //                           paddingTop: "5px",
// //                           paddingBottom: "5px",
// //                         }}
// //                       >
// //                         {t("text.FileName")}
// //                       </th>
// //                       <th
// //                         style={{
// //                           borderLeft: "1px solid black",
// //                           paddingTop: "5px",
// //                           paddingBottom: "5px",
// //                         }}
// //                       >
// //                         {t("text.PdfFile")}
// //                       </th>
// //                     </tr>
// //                   </thead>
// //                   <tbody style={{ border: "1px solid black" }}>
// //                     {tableData?.map((row: any, index: any) => (
// //                       <tr key={row.id} style={{ border: "1px solid black" }}>
// //                         <td
// //                           style={{
// //                             borderLeft: "1px solid black",
// //                             borderTop: "1px solid black",
// //                             textAlign: "center",
// //                           }}
// //                         >
// //                           <DeleteIcon
// //                             style={{
// //                               fontSize: "20px",
// //                               color: "darkred",
// //                               cursor: "pointer",
// //                             }}
// //                             onClick={() => removeExtraRow(row.id)}
// //                           />
// //                         </td>
// //                         <td
// //                           style={{
// //                             borderLeft: "1px solid black",
// //                             borderTop: "1px solid black",
// //                             textAlign: "center",
// //                           }}
// //                         >
// //                           {row.pDate}
// //                         </td>
// //                         <td
// //                           style={{
// //                             borderLeft: "1px solid black",
// //                             borderTop: "1px solid black",
// //                             textAlign: "center",
// //                           }}
// //                         >
// //                           {row.keywords}
// //                         </td>
// //                         <td
// //                           style={{
// //                             borderLeft: "1px solid black",
// //                             borderTop: "1px solid black",
// //                             textAlign: "center",
// //                           }}
// //                         >
// //                           {row.pdfName}
// //                         </td>
// //                         <td
// //                           style={{
// //                             borderLeft: "1px solid black",
// //                             borderTop: "1px solid black",
// //                             textAlign: "center",
// //                           }}
// //                         >
// //                           {getPdfSource(row) ? (
// //                             <embed
// //                               src={getPdfSource(row)}
// //                               style={{
// //                                 width: 150,
// //                                 height: 100,
// //                                 border: "1px solid grey",
// //                                 borderRadius: 10,
// //                                 padding: "2px",
// //                               }}
// //                             />
// //                           ) : (
// //                             ""
// //                           )}

// //                           <Typography
// //                             onClick={() => modalOpenHandle1(getPdfSource(row))}
// //                             style={{
// //                               textDecorationColor: "blue",
// //                               textDecorationLine: "underline",
// //                               color: "blue",
// //                               fontSize: "15px",
// //                               cursor: "pointer",
// //                             }}
// //                           >
// //                             {t("text.Preview")}
// //                           </Typography>

// //                           <Modal open={Opens} onClose={handlePanClose1}>
// //                             <Box sx={style}>
// //                               {Img == "" ? (
// //                                 <img
// //                                   src={nopdf}
// //                                   style={{
// //                                     width: "170vh",
// //                                     height: "75vh",
// //                                   }}
// //                                 />
// //                               ) : (
// //                                 <embed
// //                                   src={Img}
// //                                   style={{
// //                                     width: "170vh",
// //                                     height: "75vh",
// //                                     borderRadius: 10,
// //                                   }}
// //                                 />
// //                               )}
// //                             </Box>
// //                           </Modal>
// //                         </td>
// //                       </tr>
// //                     ))}
// //                   </tbody>
// //                 </Table>
// //               </Grid>

// //               <Grid
// //                 item
// //                 xs={12}
// //                 spacing={2}
// //                 style={{ display: "flex", justifyContent: "center" }}
// //               >
// //                 <Grid xs={6} style={{ margin: "6px" }}>
// //                   <Button
// //                     type="submit"
// //                     fullWidth
// //                     style={{
// //                       backgroundColor: `var(--header-background)`,
// //                       color: "white",
// //                       marginTop: "10px",
// //                     }}
// //                   >
// //                     {loader ?
// //                       <CircularProgress size={24} color="inherit" />
// //                       :
// //                       t("text.update")
// //                     }
// //                   </Button>
// //                 </Grid>

// //                 <Grid xs={6} style={{ margin: "6px" }}>
// //                   <Button
// //                     type="reset"
// //                     fullWidth
// //                     style={{
// //                       backgroundColor: "#F43F5E",
// //                       color: "white",
// //                       marginTop: "10px",
// //                     }}
// //                     onClick={(e) => formik.resetForm()}
// //                   >
// //                     {t("text.reset")}
// //                   </Button>
// //                 </Grid>
// //               </Grid>
// //             </Grid>
// //           </form>
// //         </CardContent>
// //       </div>
// //     </div>
// //   );
// // };
// // export default DocumentEntryEdit;







import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  Modal,
  Box,
  Table,
  CircularProgress,
  LinearProgress,
  InputAdornment,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import Autocomplete from "@mui/material/Autocomplete";
import nopdf from "../../../assets/images/nopdf.png";
import dayjs from "dayjs";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AiIcon from '@mui/icons-material/Psychology';

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vw",
  height: "85vh",
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  overflowY: 'auto',
};

type Props = {};

interface SelectOption { value: string | number; label: string; }

const documentContentKeywords: Record<string, { keywords: string[], typeLabel: string, threshold: number, regex?: RegExp[] }> = {
  FLEET_VEHICLE_REPORT: { 
    keywords: ["vehicle data", "vehicle no", "vehicle type", "time consumption", "fuel consumpt", "tipper", "dumper", "loader", "skid steer", "tata", "leyland", "truck", "hrs", "mins", "sec", "mt"],
    regex: [/[A-Z]{2}\s?\d{1,2}\s?[A-Z]{0,3}\s?\/?\s?\d{1,4}/i, /CH\.?NO\.?\s?\d+/i],
    typeLabel: "Fleet Report / Vehicle Data", 
    threshold: 4 
  },
  RESUME: { keywords: ["resume", "cv", "curriculum vitae", "experience", "education", "skills", "objective", "summary", "references", "career", "employment history", "qualification"], typeLabel: "Resume/CV", threshold: 2 },
  INVOICE: { keywords: ["invoice", "bill", "receipt", "amount due", "invoice #", "invoice number", "bill to", "ship to", "item", "quantity", "price", "total", "tax", "vat", "payment terms"], typeLabel: "Invoice/Bill", threshold: 2 },
  LETTER: { keywords: ["dear", "sincerely", "yours faithfully", "regards", "letter", "correspondence", "enclosed", "subject:", "to whom it may concern"], typeLabel: "Letter/Correspondence", threshold: 2 },
  NEWS_ARTICLE: { keywords: ["news", "article", "headline", "byline", "published", "edition", "column", "editorial", "reporter", "source", "dateline", "breaking news", "journal"], typeLabel: "News Article/Publication", threshold: 2 },
  AGREEMENT: { keywords: ["agreement", "contract", "terms and conditions", "party a", "party b", "whereas", "heretofore", "witnesseth", "binding", "legal", "nda", "memorandum of understanding"], typeLabel: "Agreement/Contract", threshold: 2 },
  REPORT: { keywords: ["report", "summary", "analysis", "findings", "conclusion", "executive summary", "introduction", "methodology", "research", "study", "annual report"], typeLabel: "General Report/Summary", threshold: 2 },
  FORM: { keywords: ["form", "application", "please fill", "submit", "signature", "date of birth", "personal details", "declaration"], typeLabel: "Form/Application", threshold: 2 },
  PRESENTATION: { keywords: ["presentation", "slides", "powerpoint", "keynote", "deck", "slide deck"], typeLabel: "Presentation", threshold: 1 },
  SPREADSHEET: { keywords: ["spreadsheet", "excel", "sheet", "workbook", "data", "table", "csv"], typeLabel: "Spreadsheet/Data", threshold: 1 },
};

const simulateAIDocumentTypeDetection = async (
  _base64Pdf: string, 
  currentFileName: string, 
  t: (key: string, defaultValue?: string) => string
): Promise<string | null> => {
  return new Promise((resolve) => {
    const contentToAnalyze = currentFileName.toLowerCase().replace(/[_-]/g, " ");
    console.log("AI Sim: Analyzing content (simulated by filename):", contentToAnalyze);
    
    setTimeout(() => {
      let detectedTypeLabel: string | null = null;
      let bestMatchScore = 0;
      let bestMatchKey: string | null = null;

      for (const docKey in documentContentKeywords) {
        const { keywords, threshold, regex } = documentContentKeywords[docKey];
        let currentScore = 0;
        
        if (regex && regex.length > 0) {
          for (const r of regex) {
            if (r.test(contentToAnalyze)) { currentScore += 3; console.log(`AI Sim: Regex match for ${docKey}`); break;  }
          }
        }
        for (const keyword of keywords) {
          if (contentToAnalyze.includes(keyword)) { currentScore++; if (docKey.toLowerCase().replace(/_/g, " ").includes(keyword.split(" ")[0])) { currentScore += 1; } }
        }
        if (currentScore >= threshold && currentScore > bestMatchScore) { bestMatchScore = currentScore; bestMatchKey = docKey; }
      }

      if (bestMatchKey) {
        detectedTypeLabel = documentContentKeywords[bestMatchKey].typeLabel;
        if (bestMatchKey === "FLEET_VEHICLE_REPORT" && contentToAnalyze.includes("fuel consum")) {
            detectedTypeLabel = t("text.aiFleetFuelReport", "Fleet Report / Vehicle Fuel Data");
        }
        console.log(`AI Sim: Detected as "${detectedTypeLabel}" (from ${bestMatchKey}) for "${currentFileName}" (score: ${bestMatchScore}).`);
      } else {
        if (currentFileName.toLowerCase().endsWith(".pdf")) { detectedTypeLabel = t("text.aiGenericDocument", "Generic Document"); }
        else { console.log(t("text.aiNoSpecificType", "AI could not determine a specific category for this attachment: ") + currentFileName); }
      }
      resolve(detectedTypeLabel);
    }, 1500); 
  });
};

// Function to validate file type and extension
const isValidFileType = (file: File): boolean => {
  // Allowed MIME types
  const allowedMimeTypes = [
    'application/pdf',
    'image/jpeg',
    'image/png',
    'image/jpg'
  ];
  
  // Allowed file extensions
  const allowedExtensions = ['.pdf', '.jpeg', '.jpg', '.png'];
  
  // Check for double extensions (e.g., file.pdf.exe)
  const fileName = file.name.toLowerCase();
  const extensionCount = (fileName.match(/\./g) || []).length;
  
  if (extensionCount > 1) {
    console.log("Rejected: Double extension detected");
    return false;
  }
  
  // Check if file extension is allowed
  const fileExtension = fileName.substring(fileName.lastIndexOf('.'));
  if (!allowedExtensions.includes(fileExtension)) {
    console.log("Rejected: Invalid file extension");
    return false;
  }
  
  // Check if MIME type is allowed
  if (!allowedMimeTypes.includes(file.type)) {
    console.log("Rejected: Invalid MIME type");
    return false;
  }
  
  // Additional check for executable files by examining the file signature
  // This is a basic check - in a real application you might want more robust validation
  if (file.type === 'application/x-msdownload' || 
      file.type === 'application/x-dosexec' ||
      file.type === 'application/x-executable' ||
      file.name.endsWith('.exe') || 
      file.name.endsWith('.bat') || 
      file.name.endsWith('.cmd') ||
      file.name.endsWith('.sh')) {
    console.log("Rejected: Executable file detected");
    return false;
  }
  
  return true;
};

const DocumentEntryEdit = (props: Props) => {
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValues = new Date(date).toISOString().split("T")[0];

  const today = moment().format("YYYY-MM-DD");

  const { i18n, t } = useTranslation();

  const [TypeOption, setTypeOption] = useState<SelectOption[]>([
    { value: "-1", label: t("text.SelectFileType") },
  ]);
  const [Subject, setSubject] = useState<SelectOption[]>([
    { value: "-1", label: t("text.SelectSubject") },
  ]);
  const [Division, setDivision] = useState<SelectOption[]>([
    { value: "-1", label: t("text.SelectDepartment") },
  ]);

  const [Opens, setOpen] = React.useState(false);
  const [Img, setImg] = useState<any>("");
  const [loader, setLoader] = useState(false);

  const [tableData, setTableData] = useState<any>([]);
  const [pDate, setPDate] = useState(today || "");
  const [keywords, setKeywords] = useState("");
  const [fileName, setfileName] = useState("");
  const [previewUrl, setPreviewUrl] = useState("");
  const [fileNameWithoutExt, setFileNameWithoutExt] = useState("");
  const [originalExtension, setOriginalExtension] = useState("");
  const [isDetectingAttachmentType, setIsDetectingAttachmentType] = useState(false);
  const [currentAttachmentAiSuggestion, setCurrentAttachmentAiSuggestion] = useState<string | null>(null);

  const handlePanClose1 = () => {
    setOpen(false);
  };
  const modalOpenHandle1 = (event: any) => {
    setOpen(true);
    setImg(event);
  };

  useEffect(() => {
    getDocManagerbyID();
    getFileType();
    getSubject();
    getDivision();
  }, []);

  const getDocManagerbyID = async () => {
    const collectData = {
      docMid: location.state.docMid,
      fileTypId: -1,
      divisionid: -1,
      subsubjId: -1,
      user_Id: -1,
      fileNo: "",
    };
    await axios
      .post(HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`, collectData)
      .then((res) => {
        var member_DocFiles;
        for (let index = 0; index < res.data.data?.length; index++) {
          member_DocFiles = res.data.data[index]["member_DocFiles"];
          const arrtabledata = [];
          for (let index = 0; index < member_DocFiles?.length; index++) {
            arrtabledata.push({
              id: index + 1,
              pdFid: member_DocFiles[index]["pdFid"] || "",
              pdfName: member_DocFiles[index]["pdfName"] || "",
              docMid: member_DocFiles[index]["docMid"] || "",
              keywords: member_DocFiles[index]["keywords"] || "",
              subFtype: member_DocFiles[index]["subFtype"] || "",
              pDate: moment(member_DocFiles[index]["pDate"] || "").format(
                "YYYY-MM-DD"
              ),
              isMain: member_DocFiles[index]["isMain"] || "",
              entryDate: member_DocFiles[index]["entryDate"] || "",
              user_id: member_DocFiles[index]["user_id"] || "",
              pdfPath: member_DocFiles[index]["pdfPath"] || "",
              pdfView: member_DocFiles[index]["pdfPath"] || "",
              srn: -1,
              isDelete: member_DocFiles[index]["isDelete"] || "",
            });
          }
          setTableData(arrtabledata);
          console.log("arrtableData", arrtabledata)
        }
      });
  };

  const getFileType = () => {
    const collectData = {
      docID: -1,
      parentDocId: -1,
      userId: "",
    };
    axios
      .post(HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`, collectData)
      .then((res) => {
        const arr: SelectOption[] = res?.data?.data?.map((item: any) => ({
          label: item.doc_Name,
          value: String(item.docID),
        })) || [];
        setTypeOption(arr);
      });
  };

  const getSubject = () => {
    const collectData = {
      sID: -1,
    };
    axios
      .post(
        HOST_URL.HOST_URL2 + `SubjectMasterForPdf/GetSubjectMasterForPdf`,
        collectData
      )
      .then((res) => {
        const arr: SelectOption[] = res.data.data.map((item: any) => ({
          label: item.subject,
          value: String(item.sId),
        })) || [];
        setSubject(arr);
      });
  };

  const getDivision = () => {
    const collectData = {
      id: -1,
      nodeID: -1,
      titleID: -1,
    };
    axios
      .post(HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`, collectData)
      .then((res) => {
        const arr: SelectOption[] = res.data.data.map((item: any) => ({
          label: item.name,
          value: String(item.id),
        })) || [];
        setDivision(arr);
      });
  };

  let navigate = useNavigate();

  const location = useLocation();
  console.log("location", location.state);

  const getAutocompleteValue = (options: SelectOption[], formikValue: string | null | number): SelectOption | null => { 
    if (formikValue === null || formikValue === undefined) return null;
    return options.find(option => String(option.value) === String(formikValue)) || null;
  };

  const validationSchema = Yup.object({
    fileNo: Yup.string().test(
      "required",
      t("text.reqFileNo"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
  });

  const formik = useFormik({
    initialValues: {
      docMid: location.state.docMid,
      fileDef: location.state.fileDef,
      fileNo: location.state.fileNo,
      synopsis: location.state.synopsis,
      status: location.state.status,
      fileType: location.state.fileType,
      subj: location.state.subj,
      complt: location.state.complt,
      fDate: dayjs(location.state.fDate).format("YYYY-MM-DD"),
      partNo: location.state.partNo,
      pFileNo: dayjs(location.state.pFileNo).format("YYYY-MM-DD"),
      perFr: dayjs(location.state.perFr).format("YYYY-MM-DD"),
      perUt: dayjs(location.state.perUt).format("YYYY-MM-DD"),
      authPersn: location.state.authPersn,
      fileTypId: String(location.state.fileTypId),
      subsubjId: String(location.state.subsubjId),
      sub_Subject_Name: location.state.sub_Subject_Name,
      divisionid: String(location.state.divisionid),
      createdate: location.state.createdate,
      user_Id: location.state.user_Id,
      userId: location.state.userId,
      member_DocFiles: [],
    },

    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setLoader(true);
      values.member_DocFiles = tableData;
      console.log("Before submission formik values", values);

      const response = await axios.post(
        HOST_URL.HOST_URL2 + `DocMangr/AddUpdateDocMangr`,
        values
      );
      if (response.data.isSuccess) {
        toast.success(response.data.mesg);
        setLoader(false);
        setTimeout(() => navigate("/DocManagement/DocumentEntry"), 1000);
      } else {
        toast.error(response.data.mesg);
        setLoader(false);
      }
    },
  });

  const requiredFields = ["fileNo"];

  const back = useNavigate();

  const onTransctionChange = async (event: any) => {
    event.preventDefault();
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      
      // Validate file type
      if (!isValidFileType(file)) {
        toast.error(t("text.invalidFileType", "Only PDF, JPEG, and PNG files are allowed"));
        event.target.value = ""; // Reset the file input
        return;
      }
      
      const currentFileName = file.name;
      const extIndex = currentFileName.lastIndexOf('.');
      const withoutExt = extIndex !== -1 ? currentFileName.substring(0, extIndex) : currentFileName;
      const ext = extIndex !== -1 ? currentFileName.substring(extIndex) : '';
      const previewUrlLocal = URL.createObjectURL(file);
      setPreviewUrl(previewUrlLocal);
      setfileName(currentFileName);
      setFileNameWithoutExt(withoutExt);
      setOriginalExtension(ext);
      setCurrentAttachmentAiSuggestion(null);
      setIsDetectingAttachmentType(true);
      try {
        //@ts-ignore
        const detectedLabel = await simulateAIDocumentTypeDetection("", currentFileName, t);
        setCurrentAttachmentAiSuggestion(detectedLabel);
        if (detectedLabel) { toast.info(t("text.aiAttachmentCategorySuggestion", `AI suggests category: ${detectedLabel}`), { autoClose: 3500 }); }
        else { toast.info(t("text.aiNoSpecificCategoryForAttachment", "AI couldn't suggest a specific category."), { autoClose: 3000 }); }
      } catch (aiError) { console.error("AI attachment category detection error:", aiError); toast.error(t("text.aiDetectionError")); }
      finally { setIsDetectingAttachmentType(false); }
    } else {
      setfileName(""); setPreviewUrl(""); setFileNameWithoutExt(""); setOriginalExtension("");
      setIsDetectingAttachmentType(false); setCurrentAttachmentAiSuggestion(null);
    }
  };

  const addMoreRow = () => { 
    if (!fileName || !pDate) { toast.warn(t("text.PleaseFillAttachmentDetails")); return; }
    if (isDetectingAttachmentType) { toast.warn(t("text.fileProcessingWait")); return; }
    const newRow = {
      id: tableData.length + 1,
      pdFid: -1,
      pdfName: fileName,
      docMid: -1,
      keywords: keywords,
      subFtype: "",
      pDate: pDate,
      isMain: "",
      entryDate: defaultValues,
      user_id: -1,
      pdfPath: "",
      pdfView: previewUrl,
      srn: -1,
      isDelete: false,
    };

    setTableData((prevTableData: any) => {
      const updatedTableDataed = [...prevTableData, newRow];
      return updatedTableDataed;
    });
    console.log(newRow);

    setfileName("");
    setPreviewUrl("");
    setPDate(today || "");
    setKeywords("");
    setFileNameWithoutExt("");
    setOriginalExtension("");
    setCurrentAttachmentAiSuggestion(null);
    const fileInput = document.getElementById('pdf_attach_file_input') as HTMLInputElement;
    if (fileInput) fileInput.value = "";
  };

  const removeExtraRow = (id: any) => {
    setTableData((prevTableData: any) => {
      const updatedTableDataed = prevTableData.filter(
        (row: any) => row.id !== id
      );
      return updatedTableDataed;
    });
  };

  const handleReset = () => { 
    formik.resetForm();
    setPDate(today || ""); setKeywords(""); setfileName(""); setPreviewUrl("");
    setFileNameWithoutExt(""); setOriginalExtension("");
    // Do not reset tableData to keep existing files
    setCurrentAttachmentAiSuggestion(null); setIsDetectingAttachmentType(false);
    const fileInput = document.getElementById('pdf_attach_file_input') as HTMLInputElement;
    if (fileInput) fileInput.value = "";
  };

  // Function to get the correct PDF source for display
  const getPdfSource = (row: any) => {
    return row.pdfView || "";
  };

  return (
    <div>
      <ToastApp />
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          marginTop: "3vh",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.DocumentEntryEdit")}
          </Typography>
          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="button"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: `var(--header-background)`,
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            <Grid item xs={12} container spacing={2}>

              <Grid item lg={4} sm={3} xs={12}>
                <TextField
                  id="fileNo"
                  name="fileNo"
                  label={
                    <span>
                      {t("text.EnterFileNo")}{" "}
                      {requiredFields.includes("fileNo") && (
                        <span
                          style={{
                            color: formik.values.fileNo ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  value={formik.values.fileNo}
                  placeholder={t("text.EnterFileNo")}
                  size="small"
                  fullWidth
                  style={{
                    backgroundColor: "white",
                    borderColor:
                      formik.touched.fileNo && formik.errors.fileNo
                        ? "red"
                        : "initial",
                  }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.fileNo && formik.errors.fileNo ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.fileNo)}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={4} sm={3} xs={12}>
                <TextField
                  id="synopsis"
                  name="synopsis"
                  label={t("text.FileName")}
                  value={formik.values.synopsis}
                  placeholder={t("text.FileName")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>

              <Grid item lg={4} sm={3} xs={12}>
                <TextField
                  id="fileDef"
                  name="fileDef"
                  label={t("text.EnterFileDef")}
                  value={formik.values.fileDef}
                  placeholder={t("text.EnterFileDef")}
                  inputProps={{}}
                  size="small"
                  type="text"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>

              <Grid item lg={4} sm={3} xs={12}>
                <TextField
                  id="perFr"
                  name="perFr"
                  label={t("text.EnterPeriodFileFrom")}
                  value={formik.values.perFr}
                  placeholder={t("text.EnterPeriodFileFrom")}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  type="date"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>

              <Grid item lg={4} sm={3} xs={12}>
                <TextField
                  id="perUt"
                  name="perUt"
                  label={t("text.EnterPeriodFileUpto")}
                  value={formik.values.perUt}
                  placeholder={t("text.EnterPeriodFileUpto")}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  type="date"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>

              <Grid item lg={4} sm={3} xs={12}>
                <TextField
                  id="authPersn"
                  name="authPersn"
                  label={t("text.EnterAuthenticatePerson")}
                  value={formik.values.authPersn}
                  placeholder={t("text.EnterAuthenticatePerson")}
                  inputProps={{}}
                  size="small"
                  type="text"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>

              <Grid item lg={4} sm={3} xs={12}>
                <TextField
                  id="fDate"
                  name="fDate"
                  label={t("text.EnterFileDate")}
                  value={formik.values.fDate}
                  placeholder={t("text.EnterFileDate")}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  type="date"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>

              <Grid item lg={4} sm={3} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={TypeOption}
                  fullWidth
                  value={getAutocompleteValue(TypeOption, formik.values.fileTypId)}
                  size="small"
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) => String(option.value) === String(value?.value)}
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("fileTypId", newValue ? String(newValue.value) : null);
                    formik.setFieldTouched("fileTypId", true);
                    formik.setFieldTouched("fileTypId", false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectFileType")} {""}
                          {requiredFields.includes("fileTypId") && (
                            <span
                              style={{
                                color: formik.values.fileTypId
                                  ? "green"
                                  : "red",
                              }}
                            >
                              *
                            </span>
                          )}
                        </span>
                      }
                    />
                  )}
                />

                {formik.touched.fileTypId && formik.errors.fileTypId ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.fileTypId)}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={4} sm={3} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={Subject}
                  fullWidth
                  size="small"
                  value={getAutocompleteValue(Subject, formik.values.subsubjId)}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) => String(option.value) === String(value?.value)}
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("subsubjId", newValue ? String(newValue.value) : null);
                    formik.setFieldValue("sub_Subject_Name", newValue?.label);
                    formik.setFieldTouched("subsubjId", true);
                  }}
                  onBlur={formik.handleBlur}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectSubject")} {""}
                          {requiredFields.includes("subsubjId") && (
                            <span
                              style={{
                                color: formik.values.subsubjId
                                  ? "green"
                                  : "red",
                              }}
                            >
                              *
                            </span>
                          )}
                        </span>
                      }
                    />
                  )}
                />
                {formik.touched.subsubjId && formik.errors.subsubjId ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.subsubjId)}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={4} sm={3} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={Division}
                  value={getAutocompleteValue(Division, formik.values.divisionid)}
                  fullWidth
                  size="small"
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) => String(option.value) === String(value?.value)}
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("divisionid", newValue ? String(newValue.value) : null);
                    formik.setFieldTouched("divisionid", true);
                    formik.setFieldTouched("divisionid", false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectDepartment")} {""}
                          {requiredFields.includes("divisionid") && (
                            <span
                              style={{
                                color: formik.values.divisionid
                                  ? "green"
                                  : "red",
                              }}
                            >
                              *
                            </span>
                          )}
                        </span>
                      }
                    />
                  )}
                />

                {formik.touched.divisionid && formik.errors.divisionid ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.divisionid)}
                  </div>
                ) : null}
              </Grid>

              <Divider />
              <br />


              <Grid item xs={12} container spacing={2}>
                <Grid xs={12} lg={2.5} item>
                  <TextField
                    id="pDate"
                    name="pDate"
                    label={t("text.EnterPeriodDate")}
                    value={pDate}
                    placeholder={t("text.EnterPeriodDate")}
                    InputLabelProps={{ shrink: true }}
                    size="small"
                    type="date"
                    fullWidth
                    style={{ backgroundColor: "white" }}
                    onChange={(e: any) => setPDate(e.target.value)}
                  />
                </Grid>

                <Grid xs={12} lg={2.5} item>
                  <TextField
                    id="keywords"
                    name="keywords"
                    label={t("text.EnterKeywords")}
                    value={keywords}
                    placeholder={t("text.EnterKeywords")}
                    size="small"
                    type="text"
                    fullWidth
                    style={{ backgroundColor: "white" }}
                    onChange={(e: any) => setKeywords(e.target.value)}
                  />
                </Grid>

                <Grid xs={12} lg={2.5} item>
                  <TextField
                    id="pdf"
                    name="pdf"
                  //  id="pdf_attach_file_input"
                    label={t("text.AttachedFile")}
                    placeholder={t("text.AttachedFile")}
                    size="small"
                    type="file"
                    fullWidth
                    style={{ backgroundColor: "white" }}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ 
                      accept: ".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png" 
                    }}
                    onChange={onTransctionChange}
                  />
                  <Typography variant="caption" display="block" sx={{ mt: 0.5, color: 'text.secondary' }}>
                    {t("text.allowedFileTypes", "Allowed: PDF, JPG, PNG")}
                  </Typography>
                  {isDetectingAttachmentType && fileName && (
                    <Box sx={{ width: '100%', mt: 0.5 }}>
                      <LinearProgress variant="indeterminate" />
                      <Typography variant="caption" display="block" textAlign="center" sx={{ color: 'text.secondary' }}>
                        {t("text.aiDetectingAttachmentCategory", "AI Detecting Category...")}
                      </Typography>
                    </Box>
                  )}
                  {currentAttachmentAiSuggestion && !isDetectingAttachmentType && fileName && (
                    <Box sx={{ mt: 0.5, p: 0.5, display: 'flex', alignItems: 'center', backgroundColor: 'rgba(0,0,0,0.03)', borderRadius: 1}}>
                        <AiIcon fontSize="small" sx={{ mr: 0.5, color: 'text.secondary' }}/>
                        <Typography variant="caption" component="span" sx={{fontStyle: 'italic', color: 'text.secondary'}}>
                            {t("text.aiSuggestsCategory", "AI Suggests Category:")} {currentAttachmentAiSuggestion}
                        </Typography>
                    </Box>
                  )}
                </Grid>

                <Grid xs={12} lg={2.5} item>
                  <TextField
                    id="fileName"
                    name="fileName"
                    label={t("text.SelectedFileName", "Selected File Name")}
                    value={fileNameWithoutExt}
                    onChange={(e) => { 
                      const newWithoutExt = e.target.value;
                      setFileNameWithoutExt(newWithoutExt); 
                      setfileName(newWithoutExt + originalExtension); 
                    }}
                    placeholder={t("text.EnterFileName")}
                    size="small"
                    type="text"
                    fullWidth
                    style={{ backgroundColor: "white" }}
                    InputProps={{ endAdornment: originalExtension ? (<InputAdornment position="end" disableTypography sx={{ pointerEvents: 'none', userSelect: 'none' }}>{originalExtension}</InputAdornment>) : null }}
                    InputLabelProps={{ shrink: Boolean(fileNameWithoutExt || originalExtension) }}
                  />
                </Grid>

                <Grid xs={12} lg={2} item>
                  <Button
                    startIcon={<AddCircleIcon />}
                    variant="contained"
                    fullWidth
                    style={{
                      marginBottom: 15,
                      backgroundColor: "info",
                    }}
                    onClick={addMoreRow}
                    disabled={!fileName || !pDate || isDetectingAttachmentType}
                  >
                    {t("text.add")}
                  </Button>
                </Grid>
              </Grid>

              <Grid xs={12} sm={12} item sx={{ marginTop: "3px" }}>
                <Table
                  style={{
                    borderCollapse: "collapse",
                    width: "100%",
                    border: "1px solid black",
                  }}
                >
                  <thead
                    style={{ backgroundColor: "#2196f3", color: "#f5f5f5" }}
                  >
                    <tr>
                      <th
                        style={{
                          borderLeft: "1px solid black",
                          paddingBlock: "10",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                        }}
                      >
                        {t("text.Action")}
                      </th>
                      <th
                        style={{
                          borderLeft: "1px solid black",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                        }}
                      >
                        {t("text.PeriodDate")}
                      </th>
                      <th
                        style={{
                          borderLeft: "1px solid black",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                        }}
                      >
                        {t("text.Keywords")}
                      </th>
                      <th
                        style={{
                          borderLeft: "1px solid black",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                        }}
                      >
                        {t("text.FileName")}
                      </th>
                      <th
                        style={{
                          borderLeft: "1px solid black",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                        }}
                      >
                        {t("text.PdfFile")}
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ border: "1px solid black" }}>
                    {tableData?.map((row: any, index: any) => (
                      <tr key={row.id} style={{ border: "1px solid black" }}>
                        <td
                          style={{
                            borderLeft: "1px solid black",
                            borderTop: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          <DeleteIcon
                            style={{
                              fontSize: "20px",
                              color: "darkred",
                              cursor: "pointer",
                            }}
                            onClick={() => removeExtraRow(row.id)}
                          />
                        </td>
                        <td
                          style={{
                            borderLeft: "1px solid black",
                            borderTop: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          {row.pDate ? moment(row.pDate).format('DD-MM-YYYY') : '-'}
                        </td>
                        <td
                          style={{
                            borderLeft: "1px solid black",
                            borderTop: "1px solid black",
                            textAlign: "left",
                          }}
                        >
                          {row.keywords || '-'}
                        </td>
                        <td
                          style={{
                            borderLeft: "1px solid black",
                            borderTop: "1px solid black",
                            textAlign: "left",
                          }}
                        >
                          {row.pdfName || '-'}
                        </td>
                        <td
                          style={{
                            borderLeft: "1px solid black",
                            borderTop: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          {getPdfSource(row) ? (
                            <>
                              <embed
                                src={getPdfSource(row)}
                                type="application/pdf"
                                style={{
                                  width: 100,
                                  height: 70,
                                  border: "1px solid grey",
                                  borderRadius: 5,
                                  padding: "2px",
                                  display: 'block',
                                  margin: '0 auto 5px auto'
                                }}
                              />
                              <Typography
                                onClick={() => modalOpenHandle1(getPdfSource(row))}
                                sx={{ 
                                  color: 'primary.main', 
                                  textDecoration: 'underline', 
                                  fontSize: '13px', 
                                  cursor: 'pointer', 
                                  '&:hover': { color: 'primary.dark' } 
                                }}
                              >
                                {t("text.Preview")}
                              </Typography>
                            </>
                          ) : (
                            <Typography variant="caption" color="textSecondary">{t("text.NoPreview", "No Preview")}</Typography>
                          )}

                          <Modal open={Opens} onClose={handlePanClose1} aria-labelledby="pdf-preview-modal-title" aria-describedby="pdf-preview-modal-description">
                            <Box sx={style}>
                              {Img ? (
                                <embed
                                  src={Img}
                                  type="application/pdf"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    borderRadius: 'inherit'
                                  }}
                                />
                              ) : ( 
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                  <img src={nopdf} alt={t("text.NoPdfPreview", "No PDF Preview")} style={{ maxWidth: "80%", maxHeight: "80%", objectFit: 'contain' }} />
                                </Box>
                              )} 
                            </Box>
                          </Modal>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Grid>

              <Grid
                item
                xs={12}
                spacing={2}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Grid xs={6} style={{ margin: "6px" }}>
                  <Button
                    type="submit"
                    fullWidth
                    style={{
                      backgroundColor: `var(--header-background)`,
                      color: "white",
                      marginTop: "10px",
                    }}
                    disabled={loader || formik.isSubmitting}
                  >
                    {formik.isSubmitting ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      t("text.update")
                    )}
                  </Button>
                </Grid>

                <Grid xs={6} style={{ margin: "6px" }}>
                  <Button
                    type="button"
                    fullWidth
                    style={{
                      backgroundColor: "#F43F5E",
                      color: "white",
                      marginTop: "10px",
                    }}
                    disabled={loader || formik.isSubmitting}
                    onClick={handleReset}
                  >
                    {t("text.reset")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </div>
    </div>
  );
};
export default DocumentEntryEdit;






// import {
//   Button,
//   Card,
//   CardContent,
//   Grid,
//   TextField,
//   Typography,
//   Divider,
//   Modal,
//   Box,
//   Table,
//   CircularProgress,
//   LinearProgress,
//   InputAdornment,
// } from "@mui/material";
// import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useNavigate, useLocation } from "react-router-dom";
// import HOST_URL from "../../../utils/Url";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { useTranslation } from "react-i18next";
// import { toast } from "react-toastify";
// import ToastApp from "../../../ToastApp";
// import Autocomplete from "@mui/material/Autocomplete";
// import nopdf from "../../../assets/images/nopdf.png";
// import dayjs from "dayjs";
// import moment from "moment";
// import DeleteIcon from "@mui/icons-material/Delete";
// import AddCircleIcon from "@mui/icons-material/AddCircle";
// import AiIcon from '@mui/icons-material/Psychology';

// const style = {
//   position: "absolute" as "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "80vw",
//   height: "85vh",
//   bgcolor: "background.paper",
//   border: "1px solid #000",
//   boxShadow: 24,
//   p: 4,
//   borderRadius: "10px",
//   overflowY: 'auto',
// };

// type Props = {};

// interface SelectOption { value: string | number; label: string; }

// const documentContentKeywords: Record<string, { keywords: string[], typeLabel: string, threshold: number, regex?: RegExp[] }> = {
//   FLEET_VEHICLE_REPORT: { 
//     keywords: ["vehicle data", "vehicle no", "vehicle type", "time consumption", "fuel consumpt", "tipper", "dumper", "loader", "skid steer", "tata", "leyland", "truck", "hrs", "mins", "sec", "mt"],
//     regex: [/[A-Z]{2}\s?\d{1,2}\s?[A-Z]{0,3}\s?\/?\s?\d{1,4}/i, /CH\.?NO\.?\s?\d+/i],
//     typeLabel: "Fleet Report / Vehicle Data", 
//     threshold: 4 
//   },
//   RESUME: { keywords: ["resume", "cv", "curriculum vitae", "experience", "education", "skills", "objective", "summary", "references", "career", "employment history", "qualification"], typeLabel: "Resume/CV", threshold: 2 },
//   INVOICE: { keywords: ["invoice", "bill", "receipt", "amount due", "invoice #", "invoice number", "bill to", "ship to", "item", "quantity", "price", "total", "tax", "vat", "payment terms"], typeLabel: "Invoice/Bill", threshold: 2 },
//   LETTER: { keywords: ["dear", "sincerely", "yours faithfully", "regards", "letter", "correspondence", "enclosed", "subject:", "to whom it may concern"], typeLabel: "Letter/Correspondence", threshold: 2 },
//   NEWS_ARTICLE: { keywords: ["news", "article", "headline", "byline", "published", "edition", "column", "editorial", "reporter", "source", "dateline", "breaking news", "journal"], typeLabel: "News Article/Publication", threshold: 2 },
//   AGREEMENT: { keywords: ["agreement", "contract", "terms and conditions", "party a", "party b", "whereas", "heretofore", "witnesseth", "binding", "legal", "nda", "memorandum of understanding"], typeLabel: "Agreement/Contract", threshold: 2 },
//   REPORT: { keywords: ["report", "summary", "analysis", "findings", "conclusion", "executive summary", "introduction", "methodology", "research", "study", "annual report"], typeLabel: "General Report/Summary", threshold: 2 },
//   FORM: { keywords: ["form", "application", "please fill", "submit", "signature", "date of birth", "personal details", "declaration"], typeLabel: "Form/Application", threshold: 2 },
//   PRESENTATION: { keywords: ["presentation", "slides", "powerpoint", "keynote", "deck", "slide deck"], typeLabel: "Presentation", threshold: 1 },
//   SPREADSHEET: { keywords: ["spreadsheet", "excel", "sheet", "workbook", "data", "table", "csv"], typeLabel: "Spreadsheet/Data", threshold: 1 },
// };

// const simulateAIDocumentTypeDetection = async (
//   _base64Pdf: string, 
//   currentFileName: string, 
//   t: (key: string, defaultValue?: string) => string
// ): Promise<string | null> => {
//   return new Promise((resolve) => {
//     const contentToAnalyze = currentFileName.toLowerCase().replace(/[_-]/g, " ");
//     console.log("AI Sim: Analyzing content (simulated by filename):", contentToAnalyze);
    
//     setTimeout(() => {
//       let detectedTypeLabel: string | null = null;
//       let bestMatchScore = 0;
//       let bestMatchKey: string | null = null;

//       for (const docKey in documentContentKeywords) {
//         const { keywords, threshold, regex } = documentContentKeywords[docKey];
//         let currentScore = 0;
        
//         if (regex && regex.length > 0) {
//           for (const r of regex) {
//             if (r.test(contentToAnalyze)) { currentScore += 3; console.log(`AI Sim: Regex match for ${docKey}`); break;  }
//           }
//         }
//         for (const keyword of keywords) {
//           if (contentToAnalyze.includes(keyword)) { currentScore++; if (docKey.toLowerCase().replace(/_/g, " ").includes(keyword.split(" ")[0])) { currentScore += 1; } }
//         }
//         if (currentScore >= threshold && currentScore > bestMatchScore) { bestMatchScore = currentScore; bestMatchKey = docKey; }
//       }

//       if (bestMatchKey) {
//         detectedTypeLabel = documentContentKeywords[bestMatchKey].typeLabel;
//         if (bestMatchKey === "FLEET_VEHICLE_REPORT" && contentToAnalyze.includes("fuel consum")) {
//             detectedTypeLabel = t("text.aiFleetFuelReport", "Fleet Report / Vehicle Fuel Data");
//         }
//         console.log(`AI Sim: Detected as "${detectedTypeLabel}" (from ${bestMatchKey}) for "${currentFileName}" (score: ${bestMatchScore}).`);
//       } else {
//         if (currentFileName.toLowerCase().endsWith(".pdf")) { detectedTypeLabel = t("text.aiGenericDocument", "Generic Document"); }
//         else { console.log(t("text.aiNoSpecificType", "AI could not determine a specific category for this attachment: ") + currentFileName); }
//       }
//       resolve(detectedTypeLabel);
//     }, 1500); 
//   });
// };

// // Function to validate file type and extension
// const isValidFileType = (file: File): boolean => {
//   // Allowed MIME types
//   const allowedMimeTypes = [
//     'application/pdf',
//     'image/jpeg',
//     'image/png',
//     'image/jpg'
//   ];
  
//   // Allowed file extensions
//   const allowedExtensions = ['.pdf', '.jpeg', '.jpg', '.png'];
  
//   // Check for double extensions (e.g., file.pdf.exe)
//   const fileName = file.name.toLowerCase();
//   const extensionCount = (fileName.match(/\./g) || []).length;
  
//   if (extensionCount > 1) {
//     console.log("Rejected: Double extension detected");
//     return false;
//   }
  
//   // Check if file extension is allowed
//   const fileExtension = fileName.substring(fileName.lastIndexOf('.'));
//   if (!allowedExtensions.includes(fileExtension)) {
//     console.log("Rejected: Invalid file extension");
//     return false;
//   }
  
//   // Check if MIME type is allowed
//   if (!allowedMimeTypes.includes(file.type)) {
//     console.log("Rejected: Invalid MIME type");
//     return false;
//   }
  
//   // Additional check for executable files by examining the file signature
//   // This is a basic check - in a real application you might want more robust validation
//   if (file.type === 'application/x-msdownload' || 
//       file.type === 'application/x-dosexec' ||
//       file.type === 'application/x-executable' ||
//       file.name.endsWith('.exe') || 
//       file.name.endsWith('.bat') || 
//       file.name.endsWith('.cmd') ||
//       file.name.endsWith('.sh')) {
//     console.log("Rejected: Executable file detected");
//     return false;
//   }
  
//   return true;
// };

// const DocumentEntryEdit = (props: Props) => {
//   var someDate = new Date();
//   var date = someDate.setDate(someDate.getDate());
//   var defaultValues = new Date(date).toISOString().split("T")[0];

//   const today = moment().format("YYYY-MM-DD");

//   const { i18n, t } = useTranslation();

//   const [TypeOption, setTypeOption] = useState<SelectOption[]>([
//     { value: "-1", label: t("text.SelectFile") },
//   ]);
//   const [Subject, setSubject] = useState<SelectOption[]>([
//     { value: "-1", label: t("text.SelectSubject") },
//   ]);
//   const [Division, setDivision] = useState<SelectOption[]>([
//     { value: "-1", label: t("text.SelectDepartment") },
//   ]);

//   const [Opens, setOpen] = React.useState(false);
//   const [Img, setImg] = useState<any>("");
//   const [loader, setLoader] = useState(false);
//   const [toaster, setToaster] = useState(false);

//   const [tableData, setTableData] = useState<any>([]);
//   const [pDate, setPDate] = useState(today || "");
//   const [keywords, setKeywords] = useState("");
//   const [fileName, setfileName] = useState("");
//   const [previewUrl, setPreviewUrl] = useState("");
//   const [fileNameWithoutExt, setFileNameWithoutExt] = useState("");
//   const [originalExtension, setOriginalExtension] = useState("");
//   const [isDetectingAttachmentType, setIsDetectingAttachmentType] = useState(false);
//   const [currentAttachmentAiSuggestion, setCurrentAttachmentAiSuggestion] = useState<string | null>(null);

//   const handlePanClose1 = () => {
//     setOpen(false);
//   };
//   const modalOpenHandle1 = (event: any) => {
//     setOpen(true);
//     setImg(event);
//   };

//   useEffect(() => {
//     getDocManagerbyID();
//     getFileType();
//     getSubject();
//     getDivision();
//   }, []);

//   const getDocManagerbyID = async () => {
//     const collectData = {
//       docMid: location.state.docMid,
//       fileTypId: -1,
//       divisionid: -1,
//       subsubjId: -1,
//       user_Id: -1,
//       fileNo: "",
//     };
//     await axios
//       .post(HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`, collectData)
//       .then((res) => {
//         var member_DocFiles;
//         for (let index = 0; index < res.data.data?.length; index++) {
//           member_DocFiles = res.data.data[index]["member_DocFiles"];
//           const arrtabledata = [];
//           for (let index = 0; index < member_DocFiles?.length; index++) {
//             arrtabledata.push({
//               id: index + 1,
//               pdFid: member_DocFiles[index]["pdFid"] || "",
//               pdfName: member_DocFiles[index]["pdfName"] || "",
//               docMid: member_DocFiles[index]["docMid"] || "",
//               keywords: member_DocFiles[index]["keywords"] || "",
//               subFtype: member_DocFiles[index]["subFtype"] || "",
//               pDate: moment(member_DocFiles[index]["pDate"] || "").format(
//                 "YYYY-MM-DD"
//               ),
//               isMain: member_DocFiles[index]["isMain"] || "",
//               entryDate: member_DocFiles[index]["entryDate"] || "",
//               user_id: member_DocFiles[index]["user_id"] || "",
//               pdfPath: member_DocFiles[index]["pdfPath"] || "",
//               pdfView: member_DocFiles[index]["pdfPath"] || "",
//               srn: -1,
//               isDelete: member_DocFiles[index]["isDelete"] || false,
//             });
//           }
//           setTableData(arrtabledata);
//           console.log("arrtableData", arrtabledata)
//         }
//       });
//   };

//   const getFileType = () => {
//     const collectData = {
//       docID: -1,
//       parentDocId: -1,
//       userId: "",
//     };
//     axios
//       .post(HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`, collectData)
//       .then((res) => {
//         const arr: SelectOption[] = res?.data?.data?.map((item: any) => ({
//           label: item.doc_Name,
//           value: String(item.docID),
//         })) || [];
//         setTypeOption(arr);
//       });
//   };

//   const getSubject = () => {
//     const collectData = {
//       sID: -1,
//     };
//     axios
//       .post(
//         HOST_URL.HOST_URL2 + `SubjectMasterForPdf/GetSubjectMasterForPdf`,
//         collectData
//       )
//       .then((res) => {
//         const arr: SelectOption[] = res.data.data.map((item: any) => ({
//           label: item.subject,
//           value: String(item.sId),
//         })) || [];
//         setSubject(arr);
//       });
//   };

//   const getDivision = () => {
//     const collectData = {
//       id: -1,
//       nodeID: -1,
//       titleID: -1,
//     };
//     axios
//       .post(HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`, collectData)
//       .then((res) => {
//         const arr: SelectOption[] = res.data.data.map((item: any) => ({
//           label: item.name,
//           value: String(item.id),
//         })) || [];
//         setDivision(arr);
//       });
//   };

//   let navigate = useNavigate();

//   const location = useLocation();
//   console.log("location", location.state);

//   const getAutocompleteValue = (options: SelectOption[], formikValue: string | null | number): SelectOption | null => { 
//     if (formikValue === null || formikValue === undefined) return null;
//     return options.find(option => String(option.value) === String(formikValue)) || null;
//   };

//   const validationSchema = Yup.object({
//     fileNo: Yup.string().test(
//       "required",
//       t("text.reqFileNo"),
//       function (value: any) {
//         return value && value.trim() !== "";
//       }
//     ),
//   });

//   const formik = useFormik({
//     initialValues: {
//       docMid: location.state.docMid,
//       fileDef: location.state.fileDef,
//       fileNo: location.state.fileNo,
//       synopsis: location.state.synopsis,
//       status: location.state.status,
//       fileType: location.state.fileType,
//       subj: location.state.subj,
//       complt: location.state.complt,
//       fDate: dayjs(location.state.fDate).format("YYYY-MM-DD"),
//       partNo: location.state.partNo,
//       pFileNo: dayjs(location.state.pFileNo).format("YYYY-MM-DD"),
//       perFr: dayjs(location.state.perFr).format("YYYY-MM-DD"),
//       perUt: dayjs(location.state.perUt).format("YYYY-MM-DD"),
//       authPersn: location.state.authPersn,
//       fileTypId: String(location.state.fileTypId),
//       subsubjId: String(location.state.subsubjId),
//       sub_Subject_Name: location.state.sub_Subject_Name,
//       divisionid: String(location.state.divisionid),
//       createdate: location.state.createdate,
//       user_Id: location.state.user_Id,
//       userId: location.state.userId,
//       member_DocFiles: [],
//     },

//     validationSchema: validationSchema,
//     onSubmit: async (values) => {
//       setLoader(true);
//       values.member_DocFiles = tableData;
//       console.log("Before submission formik values", values);

//       const response = await axios.post(
//         HOST_URL.HOST_URL2 + `DocMangr/AddUpdateDocMangr`,
//         values
//       );
//       if (response.data.isSuccess) {
//         toast.success(response.data.mesg);
//         setLoader(false);
//         setTimeout(() => navigate("/DocManagement/DocumentEntry"), 1000);
//       } else {
//         toast.error(response.data.mesg);
//         setLoader(false);
//       }
//     },
//   });

//   const requiredFields = ["fileNo"];

//   const back = useNavigate();

//   const onTransctionChange = async (event: any) => {
//     event.preventDefault();
//     if (event.target.files && event.target.files[0]) {
//       const file = event.target.files[0];
      
//       // Validate file type
//       if (!isValidFileType(file)) {
//         toast.error(t("text.invalidFileType", "Only PDF, JPEG, and PNG files are allowed"));
//         event.target.value = ""; // Reset the file input
//         return;
//       }
      
//       const currentFileName = file.name;
//       const extIndex = currentFileName.lastIndexOf('.');
//       const withoutExt = extIndex !== -1 ? currentFileName.substring(0, extIndex) : currentFileName;
//       const ext = extIndex !== -1 ? currentFileName.substring(extIndex) : '';
//       const previewUrlLocal = URL.createObjectURL(file);
//       setPreviewUrl(previewUrlLocal);
//       setfileName(currentFileName);
//       setFileNameWithoutExt(withoutExt);
//       setOriginalExtension(ext);
//       setCurrentAttachmentAiSuggestion(null);
//       setIsDetectingAttachmentType(true);
//       try {
//         //@ts-ignore
//         const detectedLabel = await simulateAIDocumentTypeDetection("", currentFileName, t);
//         setCurrentAttachmentAiSuggestion(detectedLabel);
//         if (detectedLabel) { toast.info(t("text.aiAttachmentCategorySuggestion", `AI suggests category: ${detectedLabel}`), { autoClose: 3500 }); }
//         else { toast.info(t("text.aiNoSpecificCategoryForAttachment", "AI couldn't suggest a specific category."), { autoClose: 3000 }); }
//       } catch (aiError) { console.error("AI attachment category detection error:", aiError); toast.error(t("text.aiDetectionError")); }
//       finally { setIsDetectingAttachmentType(false); }
//     } else {
//       setfileName(""); setPreviewUrl(""); setFileNameWithoutExt(""); setOriginalExtension("");
//       setIsDetectingAttachmentType(false); setCurrentAttachmentAiSuggestion(null);
//     }
//   };

//   const addMoreRow = () => { 
//     if (!fileName || !pDate) { toast.warn(t("text.PleaseFillAttachmentDetails")); return; }
//     if (isDetectingAttachmentType) { toast.warn(t("text.fileProcessingWait")); return; }
//     const newRow = {
//       id: Date.now(),
//       pdFid: -1,
//       pdfName: fileName,
//       docMid: -1,
//       keywords: keywords,
//       subFtype: "",
//       pDate: pDate,
//       isMain: "",
//       entryDate: defaultValues,
//       user_id: -1,
//       pdfPath: "",
//       pdfView: previewUrl,
//       srn: -1,
//       isDelete: false,
//     };

//     setTableData((prevTableData: any) => {
//       const updatedPrev = prevTableData.map((row:any) => ({ ...row, isDelete: true }));
//       return [...updatedPrev, newRow];
//     });

//     setfileName("");
//     setPreviewUrl("");
//     setPDate(today || "");
//     setKeywords("");
//     setFileNameWithoutExt("");
//     setOriginalExtension("");
//     setCurrentAttachmentAiSuggestion(null);
//     const fileInput = document.getElementById('pdf_attach_file_input') as HTMLInputElement;
//     if (fileInput) fileInput.value = "";
//   };

//   const removeExtraRow = (id: any) => {
//     setTableData((prevTableData: any) => 
//       prevTableData.map((row:any) => row.id === id ? { ...row, isDelete: true } : row)
//     );
//   };

//   const handleReset = () => { 
//     formik.resetForm();
//     setPDate(today || ""); setKeywords(""); setfileName(""); setPreviewUrl("");
//     setFileNameWithoutExt(""); setOriginalExtension("");
//     // Do not reset tableData to keep existing files
//     setCurrentAttachmentAiSuggestion(null); setIsDetectingAttachmentType(false);
//     const fileInput = document.getElementById('pdf_attach_file_input') as HTMLInputElement;
//     if (fileInput) fileInput.value = "";
//   };

//   // Function to get the correct PDF source for display
//   const getPdfSource = (row: any) => {
//     return row.pdfView || "";
//   };

//   return (
//     <div>
//       <ToastApp />
//       <div
//         style={{
//           padding: "-5px 5px",
//           backgroundColor: "#ffffff",
//           borderRadius: "5px",
//           marginTop: "3vh",
//         }}
//       >
//         <CardContent>
//           <Typography
//             variant="h5"
//             textAlign="center"
//             style={{ fontSize: "18px", fontWeight: 500 }}
//           >
//             {t("text.DocumentEntryEdit")}
//           </Typography>
//           <Grid item sm={4} xs={12}>
//             <Typography style={{ marginTop: "-75px" }}>
//               <Button
//                 type="button"
//                 onClick={() => back(-1)}
//                 variant="contained"
//                 style={{
//                   marginBottom: 15,
//                   marginTop: "45px",
//                   backgroundColor: `var(--header-background)`,
//                   width: 20,
//                 }}
//               >
//                 <ArrowBackSharpIcon />
//               </Button>
//             </Typography>
//           </Grid>
//           <Divider />
//           <br />
//           <form onSubmit={formik.handleSubmit}>
//             <Grid item xs={12} container spacing={2}>

//               <Grid item lg={4} sm={3} xs={12}>
//                 <TextField
//                   id="fileNo"
//                   name="fileNo"
//                   label={
//                     <span>
//                       {t("text.EnterFileNo")}{" "}
//                       {requiredFields.includes("fileNo") && (
//                         <span
//                           style={{
//                             color: formik.values.fileNo ? "green" : "red",
//                           }}
//                         >
//                           *
//                         </span>
//                       )}
//                     </span>
//                   }
//                   value={formik.values.fileNo}
//                   placeholder={t("text.EnterFileNo")}
//                   size="small"
//                   fullWidth
//                   style={{
//                     backgroundColor: "white",
//                     borderColor:
//                       formik.touched.fileNo && formik.errors.fileNo
//                         ? "red"
//                         : "initial",
//                   }}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//                 {formik.touched.fileNo && formik.errors.fileNo ? (
//                   <div style={{ color: "red", margin: "5px" }}>
//                     {String(formik.errors.fileNo)}
//                   </div>
//                 ) : null}
//               </Grid>

//               <Grid item lg={4} sm={3} xs={12}>
//                 <TextField
//                   id="synopsis"
//                   name="synopsis"
//                   label={t("text.FileName")}
//                   value={formik.values.synopsis}
//                   placeholder={t("text.FileName")}
//                   size="small"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//               </Grid>

//               <Grid item lg={4} sm={3} xs={12}>
//                 <TextField
//                   id="fileDef"
//                   name="fileDef"
//                   label={t("text.EnterFileDef")}
//                   value={formik.values.fileDef}
//                   placeholder={t("text.EnterFileDef")}
//                   inputProps={{}}
//                   size="small"
//                   type="text"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//               </Grid>

//               <Grid item lg={4} sm={3} xs={12}>
//                 <TextField
//                   id="perFr"
//                   name="perFr"
//                   label={t("text.EnterPeriodFileFrom")}
//                   value={formik.values.perFr}
//                   placeholder={t("text.EnterPeriodFileFrom")}
//                   InputLabelProps={{ shrink: true }}
//                   size="small"
//                   type="date"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//               </Grid>

//               <Grid item lg={4} sm={3} xs={12}>
//                 <TextField
//                   id="perUt"
//                   name="perUt"
//                   label={t("text.EnterPeriodFileUpto")}
//                   value={formik.values.perUt}
//                   placeholder={t("text.EnterPeriodFileUpto")}
//                   InputLabelProps={{ shrink: true }}
//                   size="small"
//                   type="date"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//               </Grid>

//               <Grid item lg={4} sm={3} xs={12}>
//                 <TextField
//                   id="authPersn"
//                   name="authPersn"
//                   label={t("text.EnterAuthenticatePerson")}
//                   value={formik.values.authPersn}
//                   placeholder={t("text.EnterAuthenticatePerson")}
//                   inputProps={{}}
//                   size="small"
//                   type="text"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//               </Grid>

//               <Grid item lg={4} sm={3} xs={12}>
//                 <TextField
//                   id="fDate"
//                   name="fDate"
//                   label={t("text.EnterFileDate")}
//                   value={formik.values.fDate}
//                   placeholder={t("text.EnterFileDate")}
//                   InputLabelProps={{ shrink: true }}
//                   size="small"
//                   type="date"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//               </Grid>

//               <Grid item lg={4} sm={3} xs={12}>
//                 <Autocomplete
//                   disablePortal
//                   id="combo-box-demo"
//                   options={TypeOption}
//                   fullWidth
//                   value={getAutocompleteValue(TypeOption, formik.values.fileTypId)}
//                   size="small"
//                   getOptionLabel={(option) => option.label}
//                   isOptionEqualToValue={(option, value) => String(option.value) === String(value?.value)}
//                   onChange={(event, newValue: any) => {
//                     console.log(newValue?.value);
//                     formik.setFieldValue("fileTypId", newValue ? String(newValue.value) : null);
//                     formik.setFieldTouched("fileTypId", true);
//                     formik.setFieldTouched("fileTypId", false);
//                   }}
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       label={
//                         <span>
//                           {t("text.SelectFile")} {""}
//                           {requiredFields.includes("fileTypId") && (
//                             <span
//                               style={{
//                                 color: formik.values.fileTypId
//                                   ? "green"
//                                   : "red",
//                               }}
//                             >
//                               *
//                             </span>
//                           )}
//                         </span>
//                       }
//                     />
//                   )}
//                 />

//                 {formik.touched.fileTypId && formik.errors.fileTypId ? (
//                   <div style={{ color: "red", margin: "5px" }}>
//                     {String(formik.errors.fileTypId)}
//                   </div>
//                 ) : null}
//               </Grid>

//               <Grid item lg={4} sm={3} xs={12}>
//                 <Autocomplete
//                   disablePortal
//                   id="combo-box-demo"
//                   options={Subject}
//                   fullWidth
//                   size="small"
//                   value={getAutocompleteValue(Subject, formik.values.subsubjId)}
//                   getOptionLabel={(option) => option.label}
//                   isOptionEqualToValue={(option, value) => String(option.value) === String(value?.value)}
//                   onChange={(event, newValue: any) => {
//                     console.log(newValue?.value);
//                     formik.setFieldValue("subsubjId", newValue ? String(newValue.value) : null);
//                     formik.setFieldValue("sub_Subject_Name", newValue?.label);
//                     formik.setFieldTouched("subsubjId", true);
//                   }}
//                   onBlur={formik.handleBlur}
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       label={
//                         <span>
//                           {t("text.SelectSubject")} {""}
//                           {requiredFields.includes("subsubjId") && (
//                             <span
//                               style={{
//                                 color: formik.values.subsubjId
//                                   ? "green"
//                                   : "red",
//                               }}
//                             >
//                               *
//                             </span>
//                           )}
//                         </span>
//                       }
//                     />
//                   )}
//                 />
//                 {formik.touched.subsubjId && formik.errors.subsubjId ? (
//                   <div style={{ color: "red", margin: "5px" }}>
//                     {String(formik.errors.subsubjId)}
//                   </div>
//                 ) : null}
//               </Grid>

//               <Grid item lg={4} sm={3} xs={12}>
//                 <Autocomplete
//                   disablePortal
//                   id="combo-box-demo"
//                   options={Division}
//                   value={getAutocompleteValue(Division, formik.values.divisionid)}
//                   fullWidth
//                   size="small"
//                   getOptionLabel={(option) => option.label}
//                   isOptionEqualToValue={(option, value) => String(option.value) === String(value?.value)}
//                   onChange={(event, newValue: any) => {
//                     console.log(newValue?.value);
//                     formik.setFieldValue("divisionid", newValue ? String(newValue.value) : null);
//                     formik.setFieldTouched("divisionid", true);
//                     formik.setFieldTouched("divisionid", false);
//                   }}
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       label={
//                         <span>
//                           {t("text.SelectDepartment")} {""}
//                           {requiredFields.includes("divisionid") && (
//                             <span
//                               style={{
//                                 color: formik.values.divisionid
//                                   ? "green"
//                                   : "red",
//                               }}
//                             >
//                               *
//                             </span>
//                           )}
//                         </span>
//                       }
//                     />
//                   )}
//                 />

//                 {formik.touched.divisionid && formik.errors.divisionid ? (
//                   <div style={{ color: "red", margin: "5px" }}>
//                     {String(formik.errors.divisionid)}
//                   </div>
//                 ) : null}
//               </Grid>

//               <Divider />
//               <br />


//               <Grid item xs={12} container spacing={2}>
//                 <Grid xs={12} lg={2.5} item>
//                   <TextField
//                     id="pDate"
//                     name="pDate"
//                     label={t("text.EnterPeriodDate")}
//                     value={pDate}
//                     placeholder={t("text.EnterPeriodDate")}
//                     InputLabelProps={{ shrink: true }}
//                     size="small"
//                     type="date"
//                     fullWidth
//                     style={{ backgroundColor: "white" }}
//                     onChange={(e: any) => setPDate(e.target.value)}
//                   />
//                 </Grid>

//                 <Grid xs={12} lg={2.5} item>
//                   <TextField
//                     id="keywords"
//                     name="keywords"
//                     label={t("text.EnterKeywords")}
//                     value={keywords}
//                     placeholder={t("text.EnterKeywords")}
//                     size="small"
//                     type="text"
//                     fullWidth
//                     style={{ backgroundColor: "white" }}
//                     onChange={(e: any) => setKeywords(e.target.value)}
//                   />
//                 </Grid>

//                 <Grid xs={12} lg={2.5} item>
//                   <TextField
//                     id="pdf"
//                     name="pdf"
//                    // id="pdf_attach_file_input"
//                     label={t("text.AttachedFile")}
//                     placeholder={t("text.AttachedFile")}
//                     size="small"
//                     type="file"
//                     fullWidth
//                     style={{ backgroundColor: "white" }}
//                     InputLabelProps={{ shrink: true }}
//                     inputProps={{ 
//                       accept: ".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png" 
//                     }}
//                     onChange={onTransctionChange}
//                   />
//                   <Typography variant="caption" display="block" sx={{ mt: 0.5, color: 'text.secondary' }}>
//                     {t("text.allowedFileTypes", "Allowed: PDF, JPG, PNG")}
//                   </Typography>
//                   {isDetectingAttachmentType && fileName && (
//                     <Box sx={{ width: '100%', mt: 0.5 }}>
//                       <LinearProgress variant="indeterminate" />
//                       <Typography variant="caption" display="block" textAlign="center" sx={{ color: 'text.secondary' }}>
//                         {t("text.aiDetectingAttachmentCategory", "AI Detecting Category...")}
//                       </Typography>
//                     </Box>
//                   )}
//                   {currentAttachmentAiSuggestion && !isDetectingAttachmentType && fileName && (
//                     <Box sx={{ mt: 0.5, p: 0.5, display: 'flex', alignItems: 'center', backgroundColor: 'rgba(0,0,0,0.03)', borderRadius: 1}}>
//                         <AiIcon fontSize="small" sx={{ mr: 0.5, color: 'text.secondary' }}/>
//                         <Typography variant="caption" component="span" sx={{fontStyle: 'italic', color: 'text.secondary'}}>
//                             {t("text.aiSuggestsCategory", "AI Suggests Category:")} {currentAttachmentAiSuggestion}
//                         </Typography>
//                     </Box>
//                   )}
//                 </Grid>

//                 <Grid xs={12} lg={2.5} item>
//                   <TextField
//                     id="fileName"
//                     name="fileName"
//                     label={t("text.SelectedFileName", "Selected File Name")}
//                     value={fileNameWithoutExt}
//                     onChange={(e) => { 
//                       const newWithoutExt = e.target.value;
//                       setFileNameWithoutExt(newWithoutExt); 
//                       setfileName(newWithoutExt + originalExtension); 
//                     }}
//                     placeholder={t("text.EnterFileName")}
//                     size="small"
//                     type="text"
//                     fullWidth
//                     style={{ backgroundColor: "white" }}
//                     InputProps={{ endAdornment: originalExtension ? (<InputAdornment position="end" disableTypography sx={{ pointerEvents: 'none', userSelect: 'none' }}>{originalExtension}</InputAdornment>) : null }}
//                     InputLabelProps={{ shrink: Boolean(fileNameWithoutExt || originalExtension) }}
//                   />
//                 </Grid>

//                 <Grid xs={12} lg={2} item>
//                   <Button
//                     startIcon={<AddCircleIcon />}
//                     variant="contained"
//                     fullWidth
//                     style={{
//                       marginBottom: 15,
//                       backgroundColor: "info",
//                     }}
//                     onClick={addMoreRow}
//                     disabled={!fileName || !pDate || isDetectingAttachmentType}
//                   >
//                     {t("text.add")}
//                   </Button>
//                 </Grid>
//               </Grid>

//               <Grid xs={12} sm={12} item sx={{ marginTop: "3px" }}>
//                 <Table
//                   style={{
//                     borderCollapse: "collapse",
//                     width: "100%",
//                     border: "1px solid black",
//                   }}
//                 >
//                   <thead
//                     style={{ backgroundColor: "#2196f3", color: "#f5f5f5" }}
//                   >
//                     <tr>
//                       <th
//                         style={{
//                           borderLeft: "1px solid black",
//                           paddingBlock: "10",
//                           paddingTop: "5px",
//                           paddingBottom: "5px",
//                         }}
//                       >
//                         {t("text.Action")}
//                       </th>
//                       <th
//                         style={{
//                           borderLeft: "1px solid black",
//                           paddingTop: "5px",
//                           paddingBottom: "5px",
//                         }}
//                       >
//                         {t("text.PeriodDate")}
//                       </th>
//                       <th
//                         style={{
//                           borderLeft: "1px solid black",
//                           paddingTop: "5px",
//                           paddingBottom: "5px",
//                         }}
//                       >
//                         {t("text.Keywords")}
//                       </th>
//                       <th
//                         style={{
//                           borderLeft: "1px solid black",
//                           paddingTop: "5px",
//                           paddingBottom: "5px",
//                         }}
//                       >
//                         {t("text.FileName")}
//                       </th>
//                       <th
//                         style={{
//                           borderLeft: "1px solid black",
//                           paddingTop: "5px",
//                           paddingBottom: "5px",
//                         }}
//                       >
//                         {t("text.PdfFile")}
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody style={{ border: "1px solid black" }}>
//                     {tableData?.filter((row: any) => !row.isDelete).map((row: any, index: number) => (
//                       <tr key={row.id} style={{ border: "1px solid black" }}>
//                         <td
//                           style={{
//                             borderLeft: "1px solid black",
//                             borderTop: "1px solid black",
//                             textAlign: "center",
//                           }}
//                         >
//                           <DeleteIcon
//                             style={{
//                               fontSize: "20px",
//                               color: "darkred",
//                               cursor: "pointer",
//                             }}
//                             onClick={() => removeExtraRow(row.id)}
//                           />
//                         </td>
//                         <td
//                           style={{
//                             borderLeft: "1px solid black",
//                             borderTop: "1px solid black",
//                             textAlign: "center",
//                           }}
//                         >
//                           {row.pDate ? moment(row.pDate).format('DD-MM-YYYY') : '-'}
//                         </td>
//                         <td
//                           style={{
//                             borderLeft: "1px solid black",
//                             borderTop: "1px solid black",
//                             textAlign: "left",
//                           }}
//                         >
//                           {row.keywords || '-'}
//                         </td>
//                         <td
//                           style={{
//                             borderLeft: "1px solid black",
//                             borderTop: "1px solid black",
//                             textAlign: "left",
//                           }}
//                         >
//                           {row.pdfName || '-'}
//                         </td>
//                         <td
//                           style={{
//                             borderLeft: "1px solid black",
//                             borderTop: "1px solid black",
//                             textAlign: "center",
//                           }}
//                         >
//                           {getPdfSource(row) ? (
//                             <>
//                               <embed
//                                 src={getPdfSource(row)}
//                                 type="application/pdf"
//                                 style={{
//                                   width: 100,
//                                   height: 70,
//                                   border: "1px solid grey",
//                                   borderRadius: 5,
//                                   padding: "2px",
//                                   display: 'block',
//                                   margin: '0 auto 5px auto'
//                                 }}
//                               />
//                               <Typography
//                                 onClick={() => modalOpenHandle1(getPdfSource(row))}
//                                 sx={{ 
//                                   color: 'primary.main', 
//                                   textDecoration: 'underline', 
//                                   fontSize: '13px', 
//                                   cursor: 'pointer', 
//                                   '&:hover': { color: 'primary.dark' } 
//                                 }}
//                               >
//                                 {t("text.Preview")}
//                               </Typography>
//                             </>
//                           ) : (
//                             <Typography variant="caption" color="textSecondary">{t("text.NoPreview", "No Preview")}</Typography>
//                           )}

//                           <Modal open={Opens} onClose={handlePanClose1} aria-labelledby="pdf-preview-modal-title" aria-describedby="pdf-preview-modal-description">
//                             <Box sx={style}>
//                               {Img ? (
//                                 <embed
//                                   src={Img}
//                                   type="application/pdf"
//                                   style={{
//                                     width: "100%",
//                                     height: "100%",
//                                     borderRadius: 'inherit'
//                                   }}
//                                 />
//                               ) : ( 
//                                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
//                                   <img src={nopdf} alt={t("text.NoPdfPreview", "No PDF Preview")} style={{ maxWidth: "80%", maxHeight: "80%", objectFit: 'contain' }} />
//                                 </Box>
//                               )} 
//                             </Box>
//                           </Modal>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </Table>
//               </Grid>

//               <Grid
//                 item
//                 xs={12}
//                 spacing={2}
//                 style={{ display: "flex", justifyContent: "center" }}
//               >
//                 <Grid xs={6} style={{ margin: "6px" }}>
//                   <Button
//                     type="submit"
//                     fullWidth
//                     style={{
//                       backgroundColor: `var(--header-background)`,
//                       color: "white",
//                       marginTop: "10px",
//                     }}
//                     disabled={loader || formik.isSubmitting}
//                   >
//                     {formik.isSubmitting ? (
//                       <CircularProgress size={24} color="inherit" />
//                     ) : (
//                       t("text.update")
//                     )}
//                   </Button>
//                 </Grid>

//                 <Grid xs={6} style={{ margin: "6px" }}>
//                   <Button
//                     type="button"
//                     fullWidth
//                     style={{
//                       backgroundColor: "#F43F5E",
//                       color: "white",
//                       marginTop: "10px",
//                     }}
//                     disabled={loader || formik.isSubmitting}
//                     onClick={handleReset}
//                   >
//                     {t("text.reset")}
//                   </Button>
//                 </Grid>
//               </Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </div>
//     </div>
//   );
// };
// export default DocumentEntryEdit;